// pages/NotFoundPage.jsx — 404 page
import { useEffect, useState } from "react";

export default function NotFoundPage({ dark }) {
  const [count, setCount] = useState(10);

  useEffect(() => {
    document.title = "404 — Page Not Found | Webilo";
    const timer = setInterval(() => {
      setCount((c) => {
        if (c <= 1) {
          clearInterval(timer);
          window.location.href = "/";
          return 0;
        }
        return c - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center px-6 text-center transition-colors duration-300 ${
        dark ? "bg-[#0F172A] text-white" : "bg-white text-[#0F172A]"
      }`}
    >
      {/* Big 404 */}
      <div className="relative mb-8 select-none">
        <span
          className="text-[160px] sm:text-[220px] font-black leading-none tracking-tighter"
          style={{
            background: dark
              ? "linear-gradient(135deg, rgba(163,230,53,0.15) 0%, rgba(163,230,53,0.05) 100%)"
              : "linear-gradient(135deg, rgba(163,230,53,0.25) 0%, rgba(163,230,53,0.08) 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          404
        </span>
        <span className="absolute inset-0 flex items-center justify-center text-[160px] sm:text-[220px] font-black leading-none tracking-tighter opacity-10">
          404
        </span>
      </div>

      {/* Icon */}
      <div className="text-5xl mb-6">🔍</div>

      {/* Text */}
      <h1 className="text-2xl sm:text-3xl font-bold mb-3 tracking-tight">
        Page Not Found
      </h1>
      <p className={`text-base max-w-md mb-2 leading-relaxed ${dark ? "text-white/50" : "text-[#0F172A]/50"}`}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <p className={`text-sm mb-10 ${dark ? "text-white/30" : "text-[#0F172A]/30"}`}>
        Redirecting to home in <span className="text-[#A3E635] font-bold">{count}</span>s...
      </p>

      {/* Buttons */}
      <div className="flex flex-col sm:flex-row gap-3">
        <a
          href="/"
          className="px-8 py-3 rounded-2xl bg-[#A3E635] text-[#0F172A] font-bold text-sm hover:bg-[#b5f23d] transition-colors"
        >
          ← Back to Home
        </a>
        <a
          href="/#contact"
          className={`px-8 py-3 rounded-2xl border font-bold text-sm transition-colors ${
            dark
              ? "border-white/20 text-white/70 hover:border-white/40 hover:text-white"
              : "border-[#E2E8F0] text-[#0F172A]/60 hover:border-[#0F172A]/30 hover:text-[#0F172A]"
          }`}
        >
          Contact Us
        </a>
      </div>

      {/* Subtle grid decoration */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          backgroundImage: "radial-gradient(circle, #A3E635 1px, transparent 1px)",
          backgroundSize: "32px 32px",
        }}
        aria-hidden="true"
      />
    </div>
  );
}
